module.exports = __webpack_public_path__ + "static/media/mobile.de2b6252.png";